import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';

import { requestFailed } from '../../app/actions/RequestFailedAction';
import { Messages } from '../../codegen/Localize';
import { FeatureFlags } from '../../ts/FeatureFlags';
import { callViaApiService } from '../../ts/restApi/personalSpace/PersonalSpace';
import {getPersonalSpace, GetPersonalSpaceAction, getPersonalSpaceSucceded, isGetPersonalSpaceAction} from '../actions/PersonalSpaceActions';

export function* rootPersonalSpaceSaga(): SagaIterator {
  yield takeEvery(getPersonalSpace, handleGetPersonalSpace);
}

export function* handleGetPersonalSpace(action: GetPersonalSpaceAction) {
  try {
    if (FeatureFlags.personalSpaceEnabled && isGetPersonalSpaceAction(action)) {
      const result =  yield call(callViaApiService);
      yield put(getPersonalSpaceSucceded(result.personalSpace));
    }
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}